import { getI18n } from '@/plugins/i18n'

import * as dataGrid from '@/composables/data-grid'
import * as dataGridColumn from '@/composables/data-grid-column'

import { useRegistryStore } from '@/stores/registry.store'
import { usePortalStore } from '@/stores/portal.store'

export const useColumns = () => {
  const i18n = getI18n()
  const registryStore = useRegistryStore()
  const portalStore = usePortalStore()

  return [
    dataGridColumn.useMultiSelectColumn({
      dataField: 'family',
      caption: i18n.t('common.family'),
      lookup: {
        dataSource: registryStore.getLocalizedDocumentFamilies(),
        valueExpr: 'id',
        displayExpr: 'name',
      },
    }),
    dataGridColumn.useMultiSelectColumn({
      dataField: 'type',
      caption: i18n.t('common.type'),
      lookup: {
        dataSource: portalStore.getLocalizedDocumentTypes(),
        valueExpr: 'id',
        displayExpr: 'name',
      }
    }),
    {
      dataField: 'series',
      caption: i18n.t('common.numerationType'),
      dataType: 'string',
    },
    {
      dataField: 'number_mnemonic',
      caption: i18n.t('common.number'),
      dataType: 'number',
      width: '14rem'
    },
    {
      dataField: 'row_number',
      caption: i18n.t('common.rowNumber'),
      dataType: 'number',
      width: '14rem'
    },
    {
      dataField: 'document_date',
      caption: i18n.t('common.documentDate'),
      dataType: 'date',
      width: '14rem'
    },
    {
      caption: i18n.t('common.subject'),
      dataField: 'subject_ref',
      lookup: dataGrid.useLookup({ store: registryStore.getSubjects()}),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      dataField: 'generating_document_ref',
      caption: i18n.t('common.generatingDocumentRef'),
      width: '14rem',
      cellTemplate: 'generatingDocumentRef'
    },
    {
      dataField: 'generated_document_ref',
      caption: i18n.t('common.generatedDocumentRef'),
      width: '14rem',
      cellTemplate: 'generatedDocumentRef'
    },
    {
      dataField: 'quantity',
      caption: i18n.t('common.quantity'),
      dataType: 'number', width: '14rem'
    },
    {
      dataField: 'rows_total_no_vat',
      format: dataGrid.useCurrencyOptions().format,
      caption: i18n.t('common.totalNoVat'),
      width: '14rem'
    },
    {
      dataField: 'rows_total_vat_sum',
      format: dataGrid.useCurrencyOptions().format,
      caption: i18n.t('common.totalVat'),
      width: '14rem'
    },
  ]
}
